export const MASK_TRANSITION_ENTER_DURATION = 1
export const MASK_TRANSITION_LEAVE_DURATION = 1
export const MASK_TRANSITION_STAGGER_AMOUNT = 0.1

export const TRANSITION_ENTER_DURATION =
  MASK_TRANSITION_ENTER_DURATION + MASK_TRANSITION_STAGGER_AMOUNT * 2
export const TRANSITION_LEAVE_DURATION =
  MASK_TRANSITION_LEAVE_DURATION + MASK_TRANSITION_STAGGER_AMOUNT * 2
